// ** Icons Import
import { Home, Book } from 'react-feather'

export default [
  {
    id: 'dashboards',
    title: 'Dashboards',
    icon: <Home size={20} />,
    navLink: '/dashboard',
    action: 'read',
    resource: 'dashboard'
  }
]
